module.exports = __webpack_public_path__ + "img/3.c7b7f62d.jpg";